import PropTypes from 'prop-types';
import cartItemShape from './cartItemShape';

export default ({
    cart_items: PropTypes.arrayOf(PropTypes.shape(cartItemShape)).isRequired,
    original_price: PropTypes.shape({
        amount: PropTypes.string.isRequired,
        currency: PropTypes.string.isRequired,
    }).isRequired,
    discount_price: PropTypes.shape({
        amount: PropTypes.string.isRequired,
        currency: PropTypes.string.isRequired,
    }).isRequired,
    final_price: PropTypes.shape({
        amount: PropTypes.string.isRequired,
        currency: PropTypes.string.isRequired,
    }).isRequired,
});
